import { useEffect } from "preact/hooks";
import { invoke } from "$store/runtime.ts";

interface Props {
  rootId: string;
}

const setup = ({ rootId }: Props) => {
  const root = document.getElementById(rootId);
  const container = root?.querySelector(
    "[data-wholesale-registration-form-container]",
  );
  const form = root?.querySelector<HTMLFormElement>(
    "[data-wholesale-registration-form]",
  );
  const showButton = root?.querySelector(
    "[data-show-wholesale-registration-form]",
  );
  const resetButton = container?.querySelector(
    "[data-reset-button]",
  );

  if (!root || !container || !form || !showButton || !resetButton) {
    console.error(
      "Missing necessary tab attributes. It will not work as intended. Necessary elements:",
      { root, container, form, showButton, rootId },
    );
    return;
  }

  const showForm = () => {
    container.setAttribute("aria-hidden", "false");
    container.scrollIntoView({ behavior: "smooth" });
  };

  const resetForm = () => {
    form.reset();
    container.removeAttribute("data-success");
  };

  const onSubmit = async (event: Event) => {
    event.preventDefault();

    // Get the form data
    const form = event.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData);

    console.log(form, "form?");
    const { status, errors, submitError } =
      await invoke["site"]
        .actions.wholesale(data);

    if (status === 400 && errors) {
      for (const [key, [value]] of Object.entries(errors)) {
        const input = form.querySelector(`[name=${key}]`);
        input?.setAttribute("data-error", "true");

        input?.addEventListener(
          "input",
          () => input.setAttribute("data-error", "false"),
          { once: true },
        );

        if (input?.nextElementSibling?.getAttribute("data-error-message")) {
          input.nextElementSibling.innerHTML = value;
        }
      }

      throw new Error("Preencha o formulário corretamente");
    }

    if (status >= 400) {
      const errorMessage = form.querySelector("& > [data-error-message]");

      if (errorMessage) {
        errorMessage.setAttribute("aria-hidden", "false");
        errorMessage.innerHTML = submitError ??
          "Ocorreu um erro inesperado. Tente novamente.";
      }

      return;
    }

    container.setAttribute("data-success", "true");
  };

  showButton.addEventListener("click", showForm);
  resetButton.addEventListener("click", resetForm);
  form.addEventListener("submit", onSubmit);

  return () => {
    showButton?.removeEventListener("click", showForm);
    resetButton?.removeEventListener("click", resetForm);
    form?.removeEventListener("submit", onSubmit);
  };
};

function FormJS({ rootId }: Props) {
  useEffect(() => setup({ rootId }), [rootId]);

  return <div data-form-controller-js />;
}

export default FormJS;
